import { render, staticRenderFns } from "./ConsultantList.vue?vue&type=template&id=63d1f442&scoped=true&"
import script from "./ConsultantList.vue?vue&type=script&lang=js&"
export * from "./ConsultantList.vue?vue&type=script&lang=js&"
import style0 from "./ConsultantList.vue?vue&type=style&index=0&id=63d1f442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d1f442",
  null
  
)

export default component.exports